import React, { useContext, useEffect } from 'react';
import Context from "../context/context";

function HiddenSearch(props)  {
  const {searchQuery, setSearchQuery} = useContext(Context);

  let searchValue = searchQuery;

  const handleSearchChange = (event) => {
    if (event.target.id === "event-search-form") {
      updateSearch(event.target["event-search-input"].value);
    }
  }

  const handleSearchClear = (event) => {
    if (event.target.id === "events-search-clear") {
      setSearchQuery("");

    }
  }

  const updateSearch = (val) => {
    setSearchQuery(val);
  }

  useEffect(() => {
    window.addEventListener('submit', handleSearchChange);

    return () => {
      window.removeEventListener('submit', handleSearchChange);
    };
  });

  useEffect(() => {
    window.addEventListener('click', handleSearchClear);

    return () => {
      window.removeEventListener('click', handleSearchClear);
    };
  });

  return (
        <input
            type="hidden"
            name="search"
            id="hidden-event-search-element"
            value={searchValue}
        />
  )

}

export default HiddenSearch;
